import { useMutation } from "@shared/lib/hooks";
import { CampaignService } from "../services/BillingBrand.service";
import { ToastService } from "@shared/lib/services";
import {
  BILLING_BRAND_LIST_QUERY_KEY,
  BILLING_BRAND_DETAILS_QUERY_KEY,
  BILLING_BRAND_FACETS_QUERY_KEY,
} from "../constants";

interface UnlinkBrandFromBillingParams {
  billingId: string;
  brandId: string;
}

export function useUnlinkBrandFromBilling() {
  const {
    mutate: unlink,
    isLoading: isUnlinking,
    isSuccess: isUnlinked,
    error,
  } = useMutation<UnlinkBrandFromBillingParams>({
    mutationFn: async ({ billingId, brandId }) => {
      try {
        return await CampaignService.unlinkBrandFromBilling(billingId, brandId);
      } catch (err: any) {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }
    },
    options: {
      queryKey: BILLING_BRAND_LIST_QUERY_KEY,
    },
    onSuccess: (c, data, { billingId }) => {
      c.invalidateQueries({ queryKey: BILLING_BRAND_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: BILLING_BRAND_DETAILS_QUERY_KEY(billingId),
      });
      c.invalidateQueries({ queryKey: BILLING_BRAND_FACETS_QUERY_KEY });
    },
  });

  return {
    unlink,
    isUnlinking,
    isUnlinked,
    error,
  };
}
